import { render } from "./TransactionAmount.vue?vue&type=template&id=727544e6"
import script from "./TransactionAmount.vue?vue&type=script&lang=js"
export * from "./TransactionAmount.vue?vue&type=script&lang=js"

import "./TransactionAmount.vue?vue&type=style&index=0&id=727544e6&lang=css"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__